/**
 * Номер запису з позначення «ПРЕФІКС-номер» («TSK-3» → «3») — голі номери, як у прототипі v4 («пов’язано з 9», «Завдання 101»); інше
 * позначення лишається як є, порожнє — порожній рядок. Чиста функція.
 */
export function displayNumber(display: string | null | undefined): string {
  if (!display) return '';
  return /-(\d+)$/.exec(display)?.[1] ?? display;
}
